import { appConfig } from '@/shared/config/app-config';

export type UnlockAccountResult = { ok: true } | { ok: false; code: 'INVALID' | 'UNKNOWN' };

export async function unlockAccount(token: string): Promise<UnlockAccountResult> {
    let response: Response;
    try {
        response = await fetch(`${appConfig.apiUrl}/auth/unlock`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token }),
        });
    } catch {
        return { ok: false, code: 'UNKNOWN' };
    }

    if (response.ok) {
        return { ok: true };
    }

    if (response.status === 410) {
        return { ok: false, code: 'INVALID' };
    }

    return { ok: false, code: 'UNKNOWN' };
}
